import { useEffect } from "react";
import { observer } from "mobx-react";
import * as Sentry from "@sentry/react";
import { useStore } from "@/stores/store-context";
import { sentryIsEnabled } from "@/sentry";

export const SentryUserSync = observer(function SentryUserSync() {
  const { user, router } = useStore();
  const userId = user.currentUser?.id ?? null;
  const workspaceSlug = router.params.workspaceSlug ?? null;

  useEffect(() => {
    if (!sentryIsEnabled()) return;
    if (userId) {
      Sentry.setUser({ id: userId });
    } else {
      Sentry.setUser(null);
    }
  }, [userId]);

  useEffect(() => {
    if (!sentryIsEnabled()) return;
    if (workspaceSlug) {
      Sentry.setTag("workspace_slug", workspaceSlug);
    } else {
      Sentry.setTag("workspace_slug", null);
    }
  }, [workspaceSlug]);

  return null;
});
